import React, { useEffect } from 'react';
import T from 'prop-types';

const HubspotEmbeddedForm = ({ formId, portalId }) => {
  const renderForm = () => {
    if (typeof hbspt === 'object') {
      hbspt.forms.create({
        region: '',
        portalId,
        formId,
        target: '#hubspotForm',
      });
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/v2.js';
    script.async = true;
    script.onload = () => renderForm();
    document.body.appendChild(script);
  }, []);

  return <div id="hubspotForm" />;
};

HubspotEmbeddedForm.propTypes = {
  formId: T.oneOfType([T.string, T.number]),
  portalId: T.oneOfType([T.string, T.number]),
};

export default HubspotEmbeddedForm;
